import { GET_COUNTRIES } from "../actions/CountryTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function CountryReducer(state = initialState, actions) {
  if (actions.type === GET_COUNTRIES) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_COUNTRIES
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { CountryReducer };
